/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('es6-promise/auto');
require('waypoints/lib/jquery.waypoints.min');

// window.Vue = require('vue');
// window.Event = new Vue();

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue ->
 * <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component',

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app'
// });

// slide out menu
require('@cmyee/pushy/js/pushy.min');
require('slick-carousel/slick/slick');

require('lightgallery/dist/js/lightgallery-all');



$(window).on('load', function (e) {
    setTimeout(
        function () {
            $('body').addClass('loaded');
        }, 500);
})

var waypoint = [];

$('.item-animate.item-animate--90').each(function (i, k) {
    waypoint[i] = new Waypoint({
        element: $(k),
        handler: function (direction) {
            console.log('Scrolled to waypoint!')
            $(k).addClass('item-animate--show');
        },
        offset: '90%'
    })
})

$('.item-animate.item-animate--80').each(function (i, k) {
    waypoint[i] = new Waypoint({
        element: $(k),
        handler: function (direction) {
            console.log('Scrolled to waypoint!')
            $(k).addClass('item-animate--show');
        },
        offset: '80%'
    })
})

$('.item-animate.item-animate--50').each(function (i, k) {
    waypoint[i] = new Waypoint({
        element: $(k),
        handler: function (direction) {
            console.log('Scrolled to waypoint!')
            $(k).addClass('item-animate--show');
        },
        offset: '50%'
    })
})



//tooltop
$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

//horizontal banner
require('./includes/horizontal-banner');

//text slider
require('./includes/text-slider');

//testimonials slider
require('./includes/testimonial-slider');

//logo slider
require('./includes/logo-slider');

require('./includes/product-slider');

require('./includes/header');

require('./includes/contact-map');



$(document).ready(function () {
    $('.menu-btn, .pushy-menu a[href="#"]').click(function (e) {
        e.preventDefault();
    });
});

$(document).ready(function () {
    if ($('.image-slider').length > 0) {
        $('.image-slider').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            arrows: true,
            draggable: false,
            autoplay: false,
            autoplaySpeed: 4000,
            adaptiveHeight: false,
            fade: false,
            cssEase: 'linear',
            responsive: [{
                breakpoint: 992, settings: {
                    slidesToShow: 3, draggable: true, arrows: false
                }
            }]
        });
    }

});

$(document).on('click', '.search-toggle', function (e) {
    e.preventDefault();

    if ($('.main-nav__icons .search-toggle').hasClass('closed')) {
        $('.main-nav__icons .search-toggle').removeClass('closed');
        $('.main-nav__icons .search-toggle').addClass('open');

        $('.main-nav__menu').addClass('show-search');
        $('.main-nav__menu .form-control').focus();

    } else {
        if ($('.main-nav__icons .search-toggle').hasClass('open')) {
            $('.main-nav__icons .search-toggle').removeClass('open');
            $('.main-nav__icons .search-toggle').addClass('closed');
            $('.main-nav__menu').removeClass('show-search');
        }
    }

});

// PREVENT INSIDE CLICK DROPDOWN
$('.dropdown-menu').on("click.bs.dropdown", function (e) {
    e.stopPropagation();
});

$(document).ready(function () {

    $('body').lightGallery({
        download: false,
        counter: false,
        selector: '.adv-image',
        thumbnail: false,
        exThumbImage: 'data-exthumbimage',
    });

    if ($('.hero-banner').length){
        // $('.header').removeClass('shadow');
    }
});

$(document).on('click', '#contact_submit', function (e) {
    e.preventDefault();
    let response = grecaptcha.getResponse();
    var fail = false;
    if (response.length < 1) {
        fail = true;
        $('#contact_form .g-recaptcha > div').addClass('warn');
    } else {
        $('#contact_form .g-recaptcha > div').removeClass('warn');
    }
    var ref = $('#contact_form').find("[required]");

    $(ref).each(function () {
        if ($(this)[0].type == "checkbox") {
            if (!$(this).is(':checked')) {
                fail = true;
                $(this).parent().addClass('warn');
            } else {
                $(this).parent().removeClass('warn');
            }
        } else if ($(this)[0].type == "select-one") {
            if ($(this).val() == '' || $(this).val() == null) {
                fail = true;
                $(this).parent().addClass('warn');
            } else {
                $(this).parent().removeClass('warn');
            }
        } else {
            if ($(this).val() == '' || $(this).val() == null) {
                fail = true;
                $(this).parent().addClass('warn');
            } else {
                $(this).parent().removeClass('warn');
            }
        }
    });
    if (fail == true) {
        $('html, body').animate({
                                    scrollTop: $('.warn:first').parents().eq(1).offset().top - 150
                                }, 350);
        $('.warn:first').focus();
        e.preventDefault();
        return false;
    } else {
        document.getElementById("contact_form").submit();
    }
});

$(document).on('click', '#enquiry_submit', function (e) {
    e.preventDefault();
    let response = grecaptcha.getResponse();
    var fail = false;
    if (response.length < 1) {
        fail = true;
        $('#enquiry_form .g-recaptcha > div').addClass('warn');
    } else {
        $('#enquiry_form .g-recaptcha > div').removeClass('warn');
    }
    var ref = $('#enquiry_form').find("[required]");

    $(ref).each(function () {
        if ($(this)[0].type == "checkbox") {
            if (!$(this).is(':checked')) {
                fail = true;
                $(this).parent().addClass('warn');
            } else {
                $(this).parent().removeClass('warn');
            }
        } else if ($(this)[0].type == "select-one") {
            if ($(this).val() == '' || $(this).val() == null) {
                fail = true;
                $(this).parent().addClass('warn');
            } else {
                $(this).parent().removeClass('warn');
            }
        } else {
            if ($(this).val() == '' || $(this).val() == null) {
                fail = true;
                $(this).parent().addClass('warn');
            } else {
                $(this).parent().removeClass('warn');
            }
        }
    });
    if (fail == true) {
        $('html, body').animate({
                                    scrollTop: $('.warn:first').parents().eq(1).offset().top - 150
                                }, 350);
        $('.warn:first').focus();
        e.preventDefault();
        return false;
    } else {
        document.getElementById("enquiry_form").submit();
    }
});
